import templateUrl from './contact-address.tpl.html';

angular
    .module('festzelt-os.contacts')
    .component('contactAddress', {
        bindings: {
            contact: '=',
        },
        controller: [
            'Users',
            '$scope',
            function (Users, $scope) {
                this.$onInit = () => {
                    this.shippingAddressEnabled = _.get(Users, 'state.company.settings.contacts.enable_shipping_address', false)
                }

                $scope.$watch(() => {
                    return this.contact;
                }, () => {
                    if(this.contact) {
                        this.activeAddress = (this.contact.business_preferred) ? 'business' : 'private';
                    }
                })
            }
        ],
        controllerAs: 'vm',
        templateUrl: templateUrl
    });



// WEBPACK FOOTER //
// ./src/app/pages/contacts/directives/sections/address/contact-address.js